<template>
    <b-modal size="lg"
             centered
             hide-footer
             content-class="rounded-xl border-0 shadow-lg"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                搜尋事項
            </strong>
        </template>

        <div class="mb-3">
            <b-form-input class="rounded-pill shadow-sm"
                          type="search"
                          placeholder="🔎 請輸入關鍵字"
                          v-model="keywordsInComponent">
            </b-form-input>
        </div>

        <div class="text-center font-weight-bold"
             v-if="filteredTasks.length === 0">
            {{ keywords.length < 2 ? "請輸入關鍵字☝️" : "沒有相關事項" }}
        </div>
        <div class="form-row">
            <div class="col-md-6"
                 v-for="task in filteredTasks"
                 v-bind:key="task._id"
                 v-on:click="hideModal">
                <kanban-card class="mb-2"
                             v-bind:task="task">
                </kanban-card>
            </div>
        </div>
    </b-modal>
</template>

<script>
import Fuse from "fuse.js";

import { BModal, BFormInput, } from "bootstrap-vue";
import KanbanCard from "../Kanban/KanbanCard";

export default {
    name: "ModalSearchTasks",
    components: {
        KanbanCard,
        BModal,
        BFormInput,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
        "keywords": {
            type: String,
        },
    },
    data () {
        return {

        };
    },
    computed: {
        keywordsInComponent: {
            get () {
                return this.keywords;
            },
            set (val) {
                this.$emit("update:keywords", val);
            }
        },
        tasks () {
            return this.$store.getters["tasks/getAllTasks"];
        },
        fuseInstance () {
            return new Fuse(
                this.tasks,
                {
                    "isCaseSensitive": false,
                    "keys": [
                        "title",
                        "site.siteName",
                        "site.address",
                        "vendorName",
                    ],
                }
            );
        },
        filteredTasks () {
            if (
                this.keywords &&
                this.keywords.length > 1
            ) {
                return this.fuseInstance
                    .search(this.keywords)
                    .map(({ item }) => item);
            }
            return [];
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
    },
}
</script>

<style lang="scss" scoped>

</style>
